import React, {Component, Fragment} from 'react'
import {Row, Col} from 'react-materialize'
import {connect} from 'react-redux'

class StylistList extends Component {
  getAvailableStylist() {
    let { stylists, services, allServices } = this.props
    // get selected services
    const foundServices = services.map(service => {
      return allServices.find(item => item.value === service.type)
    });

    let foundStylistService = [];
    // check if selected stylist can fullfil selected service
    //if stylist can do the service they are available
    if (foundServices.length > 0) {
      foundServices.forEach(service => {
        foundStylistService = [];
        stylists.forEach(stylistService => {
          return foundStylistService = stylistService.services.includes(service.id) ? [...foundStylistService, stylistService] : [...foundStylistService];
        });
      });
    }
    //else they are not available and cannot be choosen
    else {
      foundStylistService = [];
      return foundStylistService;
    }
    return foundStylistService;
  }
  render() {
    const availStylists = this.getAvailableStylist();
    return(
      <Row className={this.props.stylistOptions ? '' : 'hide'}>
        <Col s={12}>
          <div className="input-field col s12">
            <select defaultValue="" id="stylist" className="browser-default" onChange={this.props.inputHandler}>
              {
                availStylists.length > 0 ? (
                    <Fragment>
                      <option value="" disabled>Choose a stylist</option>
                      <option value="0">Any Stylist</option>
                    </Fragment>
                  ) : (
                    <option value="" disabled>No stylist available for selected service. Change service or appointment date</option>
                  )
                
              }
              { 
                availStylists && (availStylists.map(person => {
                  return (
                    <option ref={this.selectRef} key={person.id} value={person.id}>{person.firstName} {person.lastName}</option>                
                  )
                }))
              }
            </select>
            <label>Choose a stylist</label>
        </div>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = state => {
  return {
    stylists: state.stylist.stylists,
    allServices: state.stylist.services
  }
}

export default connect(mapStateToProps)(StylistList)
